import {
  ArrayInput,
  NumberInput,
  required,
  SimpleFormIterator,
  TextInput,
  useRecordContext,
} from "react-admin";
import { MyCreate } from "../../ra-lb-tools/components/myMutator";
import { LinkButton } from "../../ra-lb-tools/components/linkButton";
import { WithPermissions } from "../../ra-lb-tools/acl/withPermissions";
import { Add } from "@mui/icons-material";
import { getValidResource } from "../../ra-lb-tools/acl/tools";
import { ReferenceInputString } from "../../ra-lb-tools/components/referenceInputString";
import { useParams } from "react-router-dom";

export const AddOneOffInvoiceItemsButton = ({ noLabel }) => {
  const organization = useRecordContext();

  if (!organization) return null;
  const path = `/${getValidResource("organizations")}/${
    organization.id
  }/one-off-invoice-items`;

  return (
    <WithPermissions
      can={{
        resource: getValidResource("organizations"),
        action: "add_one_off_invoice_items",
      }}
    >
      <LinkButton
        className="AddOneOffInvoiceItemsButton"
        to={path}
        label={noLabel ? "" : "Add one off items"}
        onClick={(e) => e.stopPropagation()}
      >
        <Add />
      </LinkButton>
    </WithPermissions>
  );
};

export const AddOneOffInvoiceItems = () => {
  const orgId = useParams().id;

  return (
    <MyCreate
      customSegment={`${orgId}/one-off-invoice-items`}
      idfield="organizationId"
      permissionAction="add_one_off_invoice_items"
      columns={1}
      transform={(data) => ({
        ...data,
        items: data.items.map((item) => ({
          ...item,
          amount: item.amount * 100,
        })),
      })}
    >
      <ArrayInput source="items">
        <SimpleFormIterator inline={true}>
          <ReferenceInputString
            reference="one-off-invoice-item-types"
            source="type"
            validate={required()}
          />
          <NumberInput source="amount" validate={required()} />
          <ReferenceInputString
            reference="currencies"
            source="currency"
            validate={required()}
          />
          <TextInput source="description" />
        </SimpleFormIterator>
      </ArrayInput>
    </MyCreate>
  );
};
